import React from 'react'
import { IBonusItemV2, IBonusSection } from '@et/types/Courses'
import { GridFluid } from '@styles/global/cssGrid'
import styled from 'styled-components'
import { Sentinel } from '@styles/global/fonts'
import { colors } from '@styles/global/colors'
import { device } from '@styles/global/breakpoints'
import { IGalleryImageQuery } from '@et/types/ImageTypes'
import Img from 'gatsby-image'
import { GATSBYIMGLOADING, IMAGELOADINGENUMS } from '@et/types/Enums'
import { isHtml, orderImgQueryByNumber } from '@utils/genUtils'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getGatsbyImageData } from '@imgix/gatsby'

interface IProps {
  bonusSection: IBonusSection,
  spanColor?: string
  hideShadows?: boolean
}

function BonusesLayoutB(props: IProps) {
  function createCSSSpanColor() {
    return (
      <style dangerouslySetInnerHTML={{
        __html: `
        .bonusPriceSpan{
            color: ${props.spanColor} !important;
          } 
      `
      }} />
    )
  }
  return (
    <Wrapper className='lfm2020-bonuses et-version' hideShadows={props.hideShadows}>
      {props.spanColor && createCSSSpanColor()}
      <GridFluid className='lfm2020-bonuses__inner lfm-cssGrid'>
        <div className='lfm2020-bonuses__header'>
          <h2 className='lfm2020-h1'>Class Bonuses</h2>
        </div>

        {props.bonusSection.items.map((item, index) => {
          return (<BonusItem key={index} {...item} />)
        })}
      </GridFluid>
    </Wrapper>
  )
}


function BonusItem(props: IBonusItemV2) {
  const isDescHtml = isHtml(props.desc)
  return (
    <div className='lfm2020-bonuses__item'>
      <div className='lfm2020-bonuses__itemImg'>
        <GatsbyImage
          key={props.title}
          alt={`Bonus Item for ${props.title}}`}
          loading={GATSBYIMGLOADING.LAZY}
          image={getGatsbyImageData({
            // Must be an imgix URL
            src: `https://et-teachable.imgix.net/${props.imgName}`,
            // This can be used to set imgix params
            imgixParams: {
              auto: 'compress',
            },

            // These are passed through to the gatsby-plugin-image component
            layout: 'fullWidth',
            // backgroundColor: '#000',
            // Set either
            // aspectRatio: 4 / 3,
            // or
            sourceWidth: 4000,
            sourceHeight: 4000,
          })}
        />
      </div>
      <div className='lfm2020-bonuses__itemContent'>
        <h3>
          {props.title}
        </h3>

        {
          isDescHtml
            ? <div dangerouslySetInnerHTML={{ __html: props.desc }} />
            : <p>
              {props.desc}
            </p>
        }

      </div>
      {/*${!bonusItem.specialValue*/}
      {/*? ''*/}
      {/*: `<div class="lfm2020-bonuses__specialValue">*/}
      {/*      <div class="lfm2020-bonuses__specialValue--price">${bonusItem.specialValue}</div>*/}
      {/*      <div class="lfm2020-bonuses__specialValue--text">value</div>*/}
      {/*    </div>`}*/}
    </div>
  )
}

const Wrapper = styled.div<{ hideShadows: boolean | undefined }>`
    margin-top: 50px;
    margin-bottom: 50px;
    position: relative;
  
    .lfm2020-bonuses__header {
      grid-column: 2/4;
      grid-row: 1;
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
  
      .lfm2020-h1 {
        margin-bottom: 5px;
        color: ${props => props.theme.headlineColor};
      }
  
      p {
        font-size: 24px;
        margin: 0;
      }
      @media ${device.tablet} {
        grid-column: 2 / 14;
        margin-bottom: 40px;
        margin-left: 30px;
      }
  
      @media ${device.laptop} {
        p {
          font-size: 32px;
        }
      }
  
    }
    .lfm2020-bonuses__inner {
      grid-row-gap: 0;
      @media ${device.tablet} {
        min-height: 0;
      }
    }
    .lfm2020-bonuses__item {
      grid-column: 2/4;
      box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
      padding: 175px 35px 35px;
      border-radius: 20px;
      margin-bottom: 30px;
      margin-top: 60px;
      position: relative;
      background: #fff;
      h3 {
        margin-top: 20px;
        margin-bottom: 10px;
        font-weight: 200;
        font-size: 32px;
        line-height: 1.2;
        ${Sentinel.semiboldItalic};
        -webkit-font-smoothing: auto;
        color: ${props => props.theme.headlineColor};
      }
      img {
        width: 100%;
      }
      span {
        color: ${colors.teal.i500};
        ${Sentinel.semiboldItalic};
        font-size: 18px;
        display: block;
        padding-top: 5px;
      }
      p{
        line-height: 1.58;
        letter-spacing: -.004em;
        margin-top: .86em;
        margin-bottom: 0;
        font-size: 18px;
        span{
          padding: 0; 
          margin: 0;
          display: inline-block;
        }
      }
  
      @media ${device.tablet} {
        grid-column: span 6;
        &:nth-child(even) {
          grid-column: 2 / span 6;
        }
      }
      @media ${device.laptopTw} {
        grid-column: span 4;
        
        h3 {
          font-size: 32px;
          line-height: 1.2;
        }
        
        &:nth-child(even) {
          grid-column: span 4;
        }
        &:nth-child(2),
        &:nth-child(5),
        &:nth-child(8),
        &:nth-child(11) {
          grid-column: 2 / span 4;
        }
      }
    }
    .lfm2020-bonuses__itemImg {
      width: 194px;
      position: absolute;
      top: -40px;
      left: 35px;
      border: 15px;
      ${props => props.hideShadows ? '' :
    `box-shadow: 7px 20px 25px rgba(0, 0, 0, 0.15), 0px 10px 20px rgba(198, 198, 198, 0.64);`
  }
      
  
    }
    .lfm2020-bonuses__specialValue {
      position: absolute;
      background: ${colors.teal.i500};
      color: #fff;
      border-radius: 50%;
      font-size: 14px;
      top: 15px;
      right: 25px;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: column;
      width: 60px;
      height: 60px;
      padding: 0 15px;
      transform: rotate(-10deg);
      .lfm2020-bonuses__specialValue--price {
        font-size: 21px;
        line-height: 21px;
      }
    }
`
export default BonusesLayoutB
